import { axiosUser, axiosProvider } from "./axiosInstance";
import axiosPublic from "./axiosPublic";
import { ENDPOINTS } from "./endpoints";

// public: get active banner ads
export const getBannerAds = async () => {
  const response = await axiosUser.get(ENDPOINTS.getBannerAds);
  return response.data;
};

// get service providers
export const getServiceProviders = async ({
  categoryId,
  lat = "28.01513561793113",
  lng = "73.31617212553432",
  maxDistance = 5000,
  approval_status = "approved",
  status = "active",
  attributes = {},
}) => {
  const headers = {
    "x-client-lat": lat,
    "x-client-lng": lng,
    "x-max-distance": maxDistance,
  };

  const params = {
    approval_status,
    status,
    ...attributes,
  };

  const response = await axiosPublic.get(
    ENDPOINTS.getServiceProviders(categoryId),
    {
      headers,
      params,
    }
  );
  return response.data;
};

// Get category details by ID
export const getCategoryById = async (id) => {
  if (!id) throw new Error("Category ID is required");
  const response = await axiosUser.get(ENDPOINTS.getCategoryById(id));
  return response.data;
};

// Get provider details by ID
export const getProviderById = async (id) => {
  if (!id) throw new Error("Provider ID is required");
  const response = await axiosUser.get(ENDPOINTS.getProviderById(id));
  return response.data;
};

// get all service categories
export const getAllServiceCategories = async (
  status = "active",
  attribute = true
) => {
  const params = {};
  if (status) params.status = status;
  if (attribute !== undefined) params.attribute = attribute;

  const response = await axiosPublic.get(ENDPOINTS.getAllServiceCategories, {
    params,
  });

  return response.data;
};

// get all service
export const getAllServices = async (
  categoryId,
  status = "active",
  approvalStatus = "approved",
  attributeId
) => {
  const params = {};
  if (categoryId) params.categoryId = categoryId;
  if (status) params.status = status;
  if (attributeId) params.attributeId = attributeId;
  if (approvalStatus !== undefined) params.approvalStatus = approvalStatus;
  const response = await axiosPublic.get(ENDPOINTS.getAllServices, {
    params,
  });
  return response.data;
};

// get service by id
export const getServiceById = async (id) => {
  if (!id) throw new Error("Service ID is required");
  const response = await axiosPublic.get(ENDPOINTS.getServiceById(id));
  return response.data;
};

// Get services for a provider by providerId
export const getProviderServices = async (providerId, params) => {
  if (!providerId) throw new Error("Provider ID is required");
  const response = await axiosUser.get(
    ENDPOINTS.getProviderServices(providerId),
    { params }
  );
  return response.data;
};

// Get services for a provider by providerId
export const getProviderServicesForProvider = async (providerId, options) => {
  if (!providerId) throw new Error("Provider ID is required");
  const params = {};
  if (options?.status) params.status = options.status;
  if (options?.approvalStatus) params.approvalStatus = options.approvalStatus;
  const response = await axiosProvider.get(
    ENDPOINTS.getProviderServices(providerId),
    { params }
  );
  return response.data;
};

// Get available slots
export const getProviderSlots = async (providerId, options = {}) => {
  if (!providerId) throw new Error("Provider ID is required");
  if (!options.date) throw new Error("Date is required");
  const params = { date: options.date };
  if (options.serviceIds) params.serviceIds = options.serviceIds;
  if (options.staffIds) params.staffIds = options.staffIds;
  if (options.includeStaffAssignment !== undefined)
    params.includeStaffAssignment = options.includeStaffAssignment;
  const response = await axiosUser.get(ENDPOINTS.getProviderSlots(providerId), {
    params,
  });
  return response.data;
};

// Get available slots for provider
export const getSlotsForProvider = async (providerId, options = {}) => {
  if (!providerId) throw new Error("Provider ID is required");
  if (!options.date) throw new Error("Date is required");
  const params = { date: options.date };
  if (options.serviceIds) params.serviceIds = options.serviceIds;
  if (options.staffIds) params.staffIds = options.staffIds;
  if (options.includeStaffAssignment !== undefined)
    params.includeStaffAssignment = options.includeStaffAssignment;
  console.log("FINAL PARAMS", params, options);

  const response = await axiosProvider.get(
    ENDPOINTS.getProviderSlots(providerId),
    {
      params,
    }
  );
  return response.data;
};

// create a booking
export const createBooking = async (body) => {
  const response = await axiosUser.post(ENDPOINTS.createBooking, body);
  return response.data;
};

// cancel booking
export const cancelBookingById = async (id, data) => {
  if (!id) throw new Error("Booking ID is required");
  const response = await axiosUser.post(ENDPOINTS.cancelBookingById(id), data);
  return response.data;
};

// get my bookings
export const getMyBooking = async ({ status, category }) => {
  const params = {};
  if (status) params.status = status;
  if (category && category !== "all") params.categoryId = category;
  const response = await axiosUser.get(ENDPOINTS.getMyBookings, { params });
  return response.data;
};

// get booking by id
export const getBookingById = async (id) => {
  if (!id) throw new Error("Booking ID is required");
  const response = await axiosUser.get(ENDPOINTS.getBookingById(id));
  return response.data;
};

// get all bookings for a provider
export const getAllProviderBookings = async ({ status, category }) => {
  const params = {};
  if (status) params.status = status;
  if (category && category !== "all") params.categoryId = category;
  const response = await axiosProvider.get(ENDPOINTS.getMyBookings, { params });
  return response.data;
};

// tooggle like status for a provider
export const toggleProviderLikeStatus = async (provider) => {
  const response = await axiosUser.post(
    ENDPOINTS.toggleProviderLikeStatus(provider)
  );
  return response.data;
};

// get provider likes status
export const getLikedStatusForProvider = async (providerId) => {
  const response = await axiosUser.get(
    ENDPOINTS.getLikedStatusForProvider(providerId)
  );
  return response.data;
};

// get current user
export const getCurrentUser = async () => {
  const response = await axiosUser.get(ENDPOINTS.getCurrUser);
  return response.data;
};

// get current provider
export const getCurrentProvider = async () => {
  const response = await axiosProvider.get(ENDPOINTS.getCurrUser);
  return response.data;
};

// get provider wallet
export const getWallet = async () => {
  const response = await axiosProvider.get(ENDPOINTS.getWallet);
  return response?.data;
};

// get applicable discount for user
export const getApplicableDiscounts = async (body) => {
  if (!body?.providerId || !body?.bookingAmount) {
    throw new Error("Provider ID And Booking Amount is required");
  }
  const response = await axiosUser.post(ENDPOINTS.getApplicableDiscount, body);
  return response?.data;
};

// validate discount code
export const validateDiscountCode = async (body) => {
  const response = await axiosUser.post(ENDPOINTS.validateDiscountCode, body);
  return response?.data;
};

// apply discount code on bookings
export const applyDiscountCode = async (id, body) => {
  const response = await axiosUser.post(ENDPOINTS.applyDiscountCode(id), body);
  return response?.data;
};

// remove disocunt code on bookings
export const removeDiscountCode = async (id) => {
  const response = await axiosUser.delete(ENDPOINTS.removeDiscountCode(id));
  return response?.data;
};

// get my offline vouchers
export const getMyOfflineVouchers = async () => {
  const response = await axiosUser.get(ENDPOINTS.getOfflineVouchers);
  return response?.data;
};

// get booking steps
export const getBookingSteps = async (categoryId, serviceId) => {
  if (!categoryId) throw new Error("Category ID is required");
  const response = await axiosUser.get(
    ENDPOINTS.getBookingSteps(categoryId, serviceId)
  );
  return response?.data;
};

// upload media
export const uploadMedia = async (formData) => {
  const response = await axiosUser.post(ENDPOINTS.uploadMedia, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response?.data;
};

// get attributes by entity
export const getAttributeByEntity = async ({ categoryId, entity }) => {
  if (!categoryId || !entity)
    throw new Error("category id and entity required");
  const response = await axiosUser.get(
    ENDPOINTS.getAttributeByEntity(categoryId, entity)
  );
  return response?.data;
};

// get staff for user
export const getProviderStaff = async ({
  providerId,
  status = "active",
  approval_status = "approved",
}) => {
  if (!providerId) throw new Error("Provider ID is required");

  const response = await axiosUser.get(ENDPOINTS.getStaff, {
    params: {
      provider_id: providerId,
      status,
      approval_status,
    },
  });
  return response.data;
};

// get staff for provider
export const getStaffForProvider = async ({
  status = "active",
  approval_status = "approved",
}) => {
  const response = await axiosProvider.get(ENDPOINTS.getStaff, {
    params: {
      status,
      approval_status,
    },
  });
  return response.data;
};

// get user's wallet
export const getUsersWallet = async () => {
  const response = await axiosUser.get(ENDPOINTS.getUserWallet);
  return response.data;
};

// get wallet summary category breakdown
export const getWalletSummaryCategoryBreakdown = async () => {
  const response = await axiosUser.get(
    ENDPOINTS.getWalletSummaryCategoryBreakdown
  );
  return response.data;
};

// calculate redemption preview
export const calculateRedemptionPreview = async (params) => {
  const response = await axiosUser.post(ENDPOINTS.calculateRedemptionPreview, {
    params,
  });
  return response.data;
};

// get kcoin transaction history
export const getKcoinTransactionHistory = async (params) => {
  const response = await axiosUser.get(ENDPOINTS.getKcoinTransactionHistory, {
    params,
  });
  return response.data;
};

// get kcoin transaction detail
export const getKcoinTransactionDetail = async (id) => {
  const response = await axiosUser.get(ENDPOINTS.getKCoinTransactionDetail(id));
  return response.data;
};

// get kcoin batches
export const getKcoinBatches = async (params) => {
  const response = await axiosUser.get(ENDPOINTS.getKcoinBatches, {
    params,
  });
  return response.data;
};

// get kcoin batches detail
export const getKcoinBatchDetail = async (id) => {
  const response = await axiosUser.get(ENDPOINTS.getKcoinBatchDetail(id));
  return response.data;
};

// get referral stats
export const getReferralStats = async () => {
  const response = await axiosUser.get(ENDPOINTS.getReferralStats);
  return response?.data;
};

// get referral code
export const getReferralCode = async () => {
  const response = await axiosUser.get(ENDPOINTS.getReferralCode);
  return response?.data;
};

// get referral history
export const getReferralHistory = async () => {
  const response = await axiosUser.get(ENDPOINTS.getReferralHistory);
  return response?.data;
};

// get referral history
export const updateReferralCode = async (body) => {
  const response = await axiosUser.put(ENDPOINTS.updateReferralCode, body);
  return response?.data;
};

// get block slots
export const getBlockSlotByProvider = async (params) => {
  try {
    const response = await axiosProvider.get(
      ENDPOINTS.getBlockSlotsByProvider,
      { params }
    );
    return response?.data;
  } catch (error) {
    return false;
  }
};

// block slots
export const blockSlotByProvider = async (body) => {
  try {
    const response = await axiosProvider.post(
      ENDPOINTS.blockSlotByProvider,
      body
    );
    return response?.data;
  } catch (error) {
    return false;
  }
};

// unblock slots
export const unBlockSlotByProvider = async (body) => {
  try {
    const response = await axiosProvider.post(
      ENDPOINTS.unBlockSlotsByProvider,
      body
    );
    return response?.data;
  } catch (error) {
    return false;
  }
};

// bulk block slots
export const bulkBlockSlotByProvider = async (body) => {
  try {
    const response = await axiosProvider.post(
      ENDPOINTS.bulkBlockSlotByProvider,
      body
    );
    return response?.data;
  } catch (error) {
    return false;
  }
};

// bulk unblock slots
export const bulkUnBlockSlotByProvider = async (body) => {
  try {
    const response = await axiosProvider.post(
      ENDPOINTS.bulkUnBlockSlotsByProvider,
      body
    );
    return response?.data;
  } catch (error) {
    return false;
  }
};

// recurring block slots
export const recurringBlockSlotByProvider = async (body) => {
  try {
    const response = await axiosProvider.post(
      ENDPOINTS.recurringBlockSlotByProvider,
      body
    );
    return response?.data;
  } catch (error) {
    return false;
  }
};

// Community
export const getFollowers = async ({ userId }) => {
  const response = await axiosUser.get(ENDPOINTS.getFollowers(userId));
  return response.data;
};

export const getFollowing = async ({ userId }) => {
  const response = await axiosUser.get(ENDPOINTS.getFollowing(userId));
  return response.data;
};

export const followUser = async ({ targetUserId }) => {
  const response = await axiosUser.post(ENDPOINTS.followUser, {
    user_id: targetUserId
  });
  return response.data;
};

export const unfollowUser = async ({ targetUserId }) => {
  const response = await axiosUser.post(ENDPOINTS.unfollowUser, {
    user_id: targetUserId
  });
  return response.data;
};

export const getPostsFeed = async () => {
  const response = await axiosUser.get(ENDPOINTS.getPostsFeed);
  return response.data;
};

export const createNewPost = async (body) => {
  const response = await axiosUser.post(ENDPOINTS.createNewPost, body);
  return response.data;
};

export const getMyPosts = async () => {
  const response = await axiosUser.get(ENDPOINTS.getMyPosts);
  return response.data;
};

export const getSinglePost = async (postId) => {
  const response = await axiosUser.get(ENDPOINTS.getSinglePost(postId));
  return response.data;
};

export const updatePost = async (postId, body) => {
  const response = await axiosUser.put(ENDPOINTS.updatePost(postId), body);
  return response.data;
};

export const deletePost = async (postId) => {
  const response = await axiosUser.delete(ENDPOINTS.deletePost(postId));
  return response.data;
};

export const likeUnlikePost = async (postId) => {
  const response = await axiosUser.post(ENDPOINTS.likeUnlikePost(postId));
  return response.data;
};

export const getPostLikes = async (postId, params = {}) => {
  const response = await axiosUser.get(ENDPOINTS.getPostLikes(postId), { params });
  return response.data;
};

export const getUserPosts = async (userId) => {
  const response = await axiosUser.get(ENDPOINTS.getUserPosts(userId));
  return response.data;
};

export const getDraftPosts = async () => {
  const response = await axiosUser.get(ENDPOINTS.getDraftPosts);
  return response.data;
};

export const publishDraftPost = async (postId) => {
  const response = await axiosUser.post(ENDPOINTS.publishDraftPost(postId));
  return response.data;
};

export const getPostComments = async (postId) => {
  const response = await axiosUser.get(ENDPOINTS.getPostComments(postId));
  return response.data;
};

export const createPostComment = async (postId, body) => {
  const response = await axiosUser.post(ENDPOINTS.createPostComment(postId), body);
  return response.data;
};

export const deletePostComment = async (postId) => {
  const response = await axiosUser.delete(ENDPOINTS.deletePostComment(postId));
  return response.data;
};

export const adminDeletePost = async (postId) => {
  const response = await axiosUser.delete(ENDPOINTS.adminDeletePost(postId));
  return response.data;
};
export const getUserVehicles = async () => {
  const response = await axiosUser.get(ENDPOINTS.getUserVehicles);
  return response.data;
};

export const getDefaultVehicle = async () => {
  const response = await axiosUser.get(ENDPOINTS.getDefaultVehicle);
  return response.data;
};

export const addVehicle = async (body) => {
  const response = await axiosUser.post(ENDPOINTS.addVehicle, body);
  return response.data;
};

export const updateVehicle = async (id, body) => {
  if (!id) throw new Error("Vehicle ID is required");
  const response = await axiosUser.put(ENDPOINTS.updateVehicle(id), body);
  return response.data;
};

export const deleteVehicle = async (id) => {
  if (!id) throw new Error("Vehicle ID is required");
  const response = await axiosUser.delete(ENDPOINTS.deleteVehicle(id));
  return response.data;
};

export const setDefaultVehicle = async (id) => {
  if (!id) throw new Error("Vehicle ID is required");
  const response = await axiosUser.put(ENDPOINTS.setDefaultVehicle(id));
  return response.data;
};

export const getAddonsByCategory = async (categoryId) => {
  if (!categoryId) throw new Error("Category ID is required");
  const response = await axiosPublic.get(ENDPOINTS.getAddonsByCategory(categoryId));
  return response.data;
};

export const getSubscriptionPlans = async (categoryId, provider_id = null) => {
  if (!categoryId) throw new Error("Category ID is required");
  const params = {};
  if (provider_id) params.provider_id = provider_id;
  const response = await axiosPublic.get(ENDPOINTS.getSubscriptionPlans(categoryId), { params });
  return response.data;
};

export const purchaseSubscription = async (body) => {
  const response = await axiosUser.post(ENDPOINTS.purchaseSubscription, body);
  return response.data;
};

export const getVehicleTypes = async () => {
  const response = await axiosUser.get(ENDPOINTS.getVehicleTypes);
  return response.data;
};

export const getVehicleBrands = async (type) => {
  const params = type ? { type } : {};
  const response = await axiosUser.get(ENDPOINTS.getVehicleBrands, { params });
  return response.data;
};

export const getVehicleModels = async (brandId) => {
  if (!brandId) throw new Error("Brand ID is required");
  const response = await axiosUser.get(ENDPOINTS.getVehicleModels(brandId));
  return response.data;
};


// --- PLAY MODULE / GAME ENDPOINTS ---

/**
 * 1. Host a Game (User A)
 * @param {Object} gameData - sportCategoryId, venueProviderId, gameType, skillLevel, gameDate, startTime, endTime, maxPlayers, pricePerPlayer, description
 */
export const hostGame = async (gameData) => {
  const response = await axiosUser.post(ENDPOINTS.hostGame, gameData);
  return response.data;
};

/**
 * 2. Discover Games (User B)
 * @param {Object} filters - date, sport_category_id (Optional)
 */
export const discoverGames = async (filters = {}) => {
  const params = {};
  if (filters.date) params.date = filters.date;
  if (filters.sport_category_id) params.sport_category_id = filters.sport_category_id;

  const response = await axiosUser.get(ENDPOINTS.discoverGames, { params });
  return response.data;
};

/**
 * 3. Join a Game (User B)
 * @param {number|string} gameId
 */
export const joinGame = async (gameId) => {
  if (!gameId) throw new Error("Game ID is required to join");
  const response = await axiosUser.post(ENDPOINTS.joinGame(gameId), {});
  return response.data;
};

/**
 * 5. Leave Game (User B)
 * @param {number|string} gameId
 */
export const leaveGame = async (gameId) => {
  if (!gameId) throw new Error("Game ID is required to leave");
  const response = await axiosUser.post(ENDPOINTS.leaveGame(gameId), {});
  return response.data;
};

/**
 * 6. Cancel Game (Host Only)
 * @param {number|string} gameId
 */
export const cancelGame = async (gameId) => {
  if (!gameId) throw new Error("Game ID is required to cancel");
  const response = await axiosUser.post(ENDPOINTS.cancelGame(gameId), {});
  return response.data;
};

export const getMyGames = async () => {
  const response = await axiosUser.get(ENDPOINTS.myGames);
  return response.data;
}

// ============ ADDRESS APIs ============

// Get all addresses for the current user
export const getAllAddresses = async () => {
  const response = await axiosUser.get(ENDPOINTS.getAllAddresses);
  return response.data;
};

// Get address by ID
export const getAddressById = async (id) => {
  if (!id) throw new Error("Address ID is required");
  const response = await axiosUser.get(ENDPOINTS.getAddressById(id));
  return response.data;
};

// Create a new address
export const createAddress = async (addressData) => {
  const response = await axiosUser.post(ENDPOINTS.createAddress, addressData);
  return response.data;
};

// Update an address
export const updateAddress = async (id, addressData) => {
  if (!id) throw new Error("Address ID is required");
  const response = await axiosUser.put(ENDPOINTS.updateAddress(id), addressData);
  return response.data;
};

// Delete an address
export const deleteAddress = async (id) => {
  if (!id) throw new Error("Address ID is required");
  const response = await axiosUser.delete(ENDPOINTS.deleteAddress(id));
  return response.data;
};
